export const SEND_OTP_ECAS_SUCCESS = "SEND_OTP_ECAS_SUCCESS"
export const SEND_OTP_ECAS = "SEND_OTP_ECAS"

export const VERIFY_OTP_ECAS_SUCCESS = "VERIFY_OTP_ECAS_SUCCESS"
export const VERIFY_OTP_ECAS = "VERIFY_OTP_ECAS"

export const GET_REPORT_LIST_ECAS_SUCCESS = "GET_REPORT_LIST_ECAS_SUCCESS"
export const GET_REPORT_LIST_ECAS = "GET_REPORT_LIST_ECAS"

export const ECAS_DOWNLOAD_SUCCESS = "ECAS_DOWNLOAD_SUCCESS"
export const ECAS_DOWNLOAD = "ECAS_DOWNLOAD"

export const ECAS_UPLOAD_FILE_SUCCESS = "ECAS_UPLOAD_FILE_SUCCESS"
export const ECAS_UPLOAD_FILE = "ECAS_UPLOAD_FILE"

export const VALIDATE_QR_SUCCESS = "VALIDATE_QR_SUCCESS"
export const VALIDATE_QR = "VALIDATE_QR"

export interface SendOtpEcasRequestBody {
    pan: string;
    email: string;
    mobile: string;
    toDate: string;
    fromDate: string;
    status: string;
    countryCode: string;
    redirectUrl: string;
    clientCode: string;
}

export interface SendOtpEcasResponseBody {
    mfc_redirect_url?: string;
    clientRefNo?: string;
    isSuccess: boolean,
    email: string;
    mobile: string;
    message: string,
    result: {
        reqId: string;
    }
}

export interface VerifyOtpEcasRequestBody {
    pan: string;
    enteredOTP: string;
    reqId: string;
}

export interface VerifyOtpEcasResponseBody {
    isSuccess: boolean;
    message: string;
    result: {
        reqId: string;
    }
}

export interface GetReportListEcasRequestBody {
    pan: string;
    clientCode: string;
    currentPage: number;
    rowsPerPage: number;
}

export interface ReportListEcas {
    id: number;
    requestDate: string;
    fromDate: string;
    toDate: string;
    reqId: string;
    status: string;
}

export interface GetReportListEcasResponseBody {
    isSuccess: boolean;
    message: string;
    result: {
        count: number;
        docsRequestList: Array<ReportListEcas>
    }
}

export interface ecasDownloadRequestBody {
    reqId: string;
}

export interface eCasUploadFileReq {
    pdf_file: File;
    password: string;
    ecas_type: string;
    pan: string;
    clientCode: string
}